module.exports = __webpack_public_path__ + "img/2ENG_Cover.3c2018ad.jpg";